/* Package JSON Import will be here */
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import { push } from "connected-react-router";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import HorizontalProductItem from "components/products/HorizontalProductItem";
import { getSimilarProducts } from "reducers/similarProducts";
import { Spinner } from "components/Spinner";
import NoData from "components/reusable/NoData";
import { appRoutesConst } from "app/navigation";
import Constants from "utilities/appConstants";
import { leftArrow, rightArrow } from "components/reusable/horizontalScroll";
/* Project Import will be here */

class SimilarProducts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    if (this.props.selectedProductId !== 0)
      this.props.actions.getSimilarProducts(this.props.selectedProductId);
  }

  viewAllSimilarProducts = () => {
    this.props.actions.push(`${appRoutesConst.viewAllProducts}/${Constants.PAGE_TYPE_SIMILAR_PRODUCTS}`);
  };

  renderComponent = () => {
    const { similarProducts, translate } = this.props;

    if (similarProducts.isLoading) {
      return (<Spinner message={translate("products.similarProducts.loading")} />)
    }
    else if (similarProducts.ids.length <= 0) {
      return (<NoData NoDataMessage={translate("products.similarProducts.noData")} />)
    }
    else {
      return (
        <ScrollMenu className="home-menu-slider"
          LeftArrow={leftArrow}
          RightArrow={rightArrow}>
          {similarProducts.groupIds.map(id => {
            return (
              <HorizontalProductItem
                itemId={`element-${id}`}
                type={Constants.REDUCER_SIMILAR_PRODUCTS}
                variants={similarProducts.group[id]}
                products={similarProducts.data}
                key={id} />)
          })}
        </ScrollMenu>)

    }
  };

  render() {
    return (
      <div className="w-100">
        <h6 className="ml-2 font-bold">{this.props.translate("products.similarProducts.title")}</h6>

        {this.renderComponent()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    similarProducts: state.similarProducts,
    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        getSimilarProducts,
        leftArrow,
        rightArrow,
        push
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SimilarProducts);